module.exports = __webpack_public_path__ + "img/tps-ecosystem.6b58f616.png";